import { CHECKOUT_FEATURE_KEY } from '@common/data-access-checkout';
import { CHECKOUT_BASKET_FEATURE_KEY } from '@common/data-access-checkout-basket';
import { FEATURE_CONFIG_FEATURE_KEY } from '@common/data-access-feature-config';
import { PERSONAL_DETAILS_FEATURE_KEY } from '@common/data-access-personal-details';
import { ActionReducer } from '@ngrx/store';
import { BASKET_FEATURE_KEY } from '@sky/data-access-basket';
import { CATALOG_FEATURE_KEY } from '@sky/data-access-catalog';
import { LocalStorageConfig, localStorageSync } from 'ngrx-store-localstorage';

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: [
      CATALOG_FEATURE_KEY,
      BASKET_FEATURE_KEY,
      CHECKOUT_BASKET_FEATURE_KEY,
      CHECKOUT_FEATURE_KEY,
      PERSONAL_DETAILS_FEATURE_KEY,
      FEATURE_CONFIG_FEATURE_KEY,
    ],
    storage: sessionStorage,
    rehydrate: true,
  } as LocalStorageConfig)(reducer);
}
